import { useNavigate, useLocation } from "react-router-dom";
import { MapPin, Compass, Library, CreditCard, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV_ITEMS = [
  { path: "/explore",    icon: MapPin,          label: "Explore" },
  { path: "/plan-tour",  icon: Compass,         label: "Plan" },
  { path: "/dashboard",  icon: Library,          label: "Library" },
  { path: "/pricing",    icon: CreditCard,       label: "credits", isCredits: true },
  { path: "/settings",   icon: User,             label: "Profile" },
];

export const BottomNav = ({ active, onActiveClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const currentPath = active || location.pathname;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-background/95 backdrop-blur border-t z-10 lg:hidden mobile-nav">
      <div className="flex items-center justify-around">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = currentPath === item.path;
          return (
            <button
              key={item.path}
              className={`mobile-nav-item ${isActive ? "active" : "text-muted-foreground"}`}
              onClick={() => {
                if (!isActive) navigate(item.path);
                else if (onActiveClick) onActiveClick(item.path);
              }}
              data-testid={`nav-${item.path.replace("/", "")}`}
            >
              <Icon className="w-7 h-7" />
              <span className={`text-xs ${isActive ? "font-semibold" : "font-medium"}`}>
                {item.isCredits ? (user?.credits || 0) : item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
